import { render, staticRenderFns } from "./TechProtectionNotification.vue?vue&type=template&id=4c715926&"
import script from "./TechProtectionNotification.vue?vue&type=script&lang=js&"
export * from "./TechProtectionNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports